// import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function VideoModal_BS({ show, onHide, videoId, title }) {
  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      centered
    >
      {/* <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header> */}
      <Modal.Body
        style={{
          // padding: "6px 6px 0px 6px",
          paddingTop: "75%",
          position: "relative",
        }}
      >
        {/* <h4>Centered Modal</h4>
        <p>
        Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
        dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
        consectetur ac, vestibulum at eros.
      </p> */}
        <iframe
          // className="ratio ratio-4x3"
          // width="560"
          // height="315"
          // src={`https://www.youtube.com/embed/${props.videoid}`}
          src={`https://www.youtube-nocookie.com/embed/${videoId}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            width: "100%",
            height: "100%",
            // maxHeight: "75vh",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        ></iframe>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default VideoModal_BS;
